export default "__VITE_ASSET__Bam18IJh__"